module.exports = __webpack_public_path__ + "img/tag.1a0a8225.svg";